import React, {Component} from 'react';

class About extends Component {
    render() {
        if(this.props.data) {
            var {bio, image, work, game, webpage} = this.props.data;
            var profilepic = image ? "images/" + image : "";
        }

        return (
            <section id="about">
                <div className="row">
                    <div className="three columns">
                        <img className="profile-pic" src={profilepic} alt="Cody Maki Profile Pic"/>
                    </div>
                    <div className="nine columns main-col">
                        <h2>About Me</h2>
                        <p>{bio}</p>
                        <h3>About My Work</h3>
                        <p>{work}</p>
                        <h3>About My Game</h3>
                        <p>{game}</p>
                        <h3>Plans for this page</h3>
                        <p>{webpage}</p>
                    </div>
                </div>
            </section>
        );
    }
}

export default About;
